import React from 'react';
import { Gallery } from 'Components/organisms/Gallery';

export const getListGallery = mediaContent => (
  <Gallery
    mode="list"
    media={mediaContent}
    mediaLazyLoad
  />
);
